import React from 'react';
import * as Hooks from 'util/hooks';

import noImageSvg from 'assets/svg/noimage.svg';
import noImageSvgWhite from 'assets/svg/noimage-white.svg';
import './image.less';

const Image = React.memo(function Image({ children, bgDark, ...props }) {
  const [hasError, setError] = Hooks.useBoolean(false);

  React.useEffect(() => {
    setError.false();
  }, [props.src, setError]);

  return !hasError ? (
    <img onError={setError.true} {...props} />
  ) : children ? (
    children
  ) : (
    <img {...props} src={bgDark ? noImageSvgWhite : noImageSvg} />
  );
});

export default Image;
